exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1s08N{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._34NpN{padding:7px 21px;border-color:#c4c4c4;background:#fff;color:#484848;font-weight:700;font-size:14px;border-radius:2px}.ZwaCH{border-color:#149ce9;background-color:#149cef;color:#fff;font-family:inherit}._34oyF{padding:9px 27px}.ZwaCH:active,.ZwaCH:active:focus,.ZwaCH:active:hover,.ZwaCH:focus,.ZwaCH:hover{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._23n-0,._23n-0:active,._23n-0:active:focus,._23n-0:active:hover,._23n-0:focus,._23n-0:hover{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._3Z11I{border-radius:0}._3WAGJ{border-radius:4px;padding:9px 21px}._20Fsi{margin-bottom:6px}._2Muxy{margin-bottom:12px}._2BEn4{margin-bottom:18px}.Y-Yzz{margin-bottom:24px}.i7GKE{margin-bottom:36px}._3bKJ9{margin-bottom:48px}._224qZ{margin-top:6px}._2W6kR{margin-top:12px}._1SBDg{margin-top:18px}._19Vhh{margin-top:24px}._2Bs3-{margin-top:36px}._3yDqb{margin-top:48px}.CUS1r{margin:0}._18Ccj{padding:0}._1Bd-v{border:0 none!important}._3zd1u{padding:50px 0;border:1px solid #dce0e0;background:#fff}._1YycP{padding:0 50px}._36cIT{text-align:center}.QJD6c{margin:0 auto}.q3He6,.QJD6c{position:relative}.q3He6{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:inline-block;overflow:hidden;background-color:#bbb;border-radius:50%;border:2px solid #fff}._3uaY_{font-size:18px;font-weight:700;color:#484848}._2TXje{font-size:14px;color:#767676}._2x5Oj{margin-top:15px;margin-bottom:15px;border:0;border-top:2px solid #9b9b9b}.V4-qC{font-weight:700}@media screen and (max-width:768px){._1FN-S{display:none}}@media screen and (max-width:640px){._1YycP{padding:0 25px}}._3MRIH{padding-top:8px;padding-bottom:14px;border-radius:0}._1mY0I{margin-left:-6px;margin-right:-6px}._3ayeM{margin:0;padding:10px;text-align:left}._33TBi{text-align:right;padding:20px}.Z-OKc{height:60px!important;border:0;margin-top:0;box-shadow:none;padding:20px}._15_DX{margin-left:10px}._1Pqlf{background-color:#f4f4f4;margin:0}._2MrPM{color:#767676}._2MrPM:focus,._2MrPM:hover{color:#767676;text-decoration:none;outline:none}._17dIr{margin-left:0;margin-right:0}._17dIr,.nIMWY{position:relative;border-radius:0}.nIMWY{display:block;height:auto;box-shadow:0 1px 3px 0 rgba(75,75,75,.25)}._3SI6S{border-radius:0 14px 14px 14px}._9F2hS{border-radius:14px 0 14px 14px}._1N9dl{text-transform:uppercase}._38I1V{overflow:hidden;text-align:center}._2HCzq{position:relative}._2HCzq:before{right:100%;margin-right:15px}._2HCzq:after,._2HCzq:before{content:\"\";position:absolute;border-bottom:1px solid #dce0e0;width:500px;top:50%}._2HCzq:after{left:100%;margin-left:15px}._1XoA_{box-shadow:0 1px 3px 0 rgba(75,75,75,.25);border:0}._2KKuJ{box-shadow:0 1px 3px 0 rgba(75,75,75,.4);border:0}._3T9Md{margin-top:15px;margin-bottom:15px;border:0;border-top:1px solid #dce0e0}._3kp34{text-align:left}._1Au9K{text-align:right}._1tjgM{color:#9b9b9b;font-size:14px}._2pF9X{margin-top:10px}._2pF9X,._3Vuos{font-size:1.5em;font-weight:400;font-style:normal}._3Q-44{font-size:14px;color:#484848}._201XE{float:left}._2V2P3{float:right}._2A1Wu{color:#3fb34f}a,a:active,a:focus,a:hover{text-decoration:none}", ""]);

// exports
exports.locals = {
	"errorMessage": "_1s08N",
	"btn": "_34NpN",
	"btnPrimary": "ZwaCH",
	"btnlarge": "_34oyF",
	"btnPrimaryBorder": "_23n-0",
	"btnRadius": "_3Z11I",
	"linkBtn": "_3WAGJ",
	"space1": "_20Fsi",
	"space2": "_2Muxy",
	"space3": "_2BEn4",
	"space4": "Y-Yzz",
	"space5": "i7GKE",
	"space6": "_3bKJ9",
	"spaceTop1": "_224qZ",
	"spaceTop2": "_2W6kR",
	"spaceTop3": "_1SBDg",
	"spaceTop4": "_19Vhh",
	"spaceTop5": "_2Bs3-",
	"spaceTop6": "_3yDqb",
	"noMargin": "CUS1r",
	"noPadding": "_18Ccj",
	"noBorder": "_1Bd-v",
	"sidebarDesign": "_3zd1u",
	"sidebarContainer": "_1YycP",
	"textCenter": "_36cIT",
	"profileAvatarSection": "QJD6c",
	"profileAvatarLink": "q3He6",
	"profileName": "_3uaY_",
	"profileDetail": "_2TXje",
	"horizontalLine": "_2x5Oj",
	"textGray": "_1tjgM",
	"textBold": "V4-qC",
	"textLeft": "_3kp34",
	"textRight": "_1Au9K",
	"hideSm": "_1FN-S",
	"contextPadding": "_3MRIH",
	"rowCondensed": "_1mY0I",
	"textBody": "_3ayeM",
	"bottomButton": "_33TBi",
	"textBox": "Z-OKc",
	"btnRight": "_15_DX",
	"panelDark": "_1Pqlf",
	"timeText": "_2MrPM",
	"panelQuote": "_17dIr",
	"panelBubble": "nIMWY",
	"panelBubbleLeft": "_3SI6S",
	"panelBubbleRight": "_9F2hS",
	"inlineStatus": "_1N9dl",
	"horizontalText": "_38I1V",
	"textWrapper": "_2HCzq",
	"shadow": "_1XoA_",
	"shadowDark": "_2KKuJ",
	"horizondalLine": "_3T9Md",
	"chevronIcon": "_2pF9X",
	"timerIcon": "_3Vuos",
	"checkInDate": "_3Q-44",
	"pullLeft": "_201XE",
	"pullRight": "_2V2P3",
	"discountText": "_2A1Wu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ViewMessage/ViewMessage.css
// module id = 2581
// module chunks = 15